export default {
  login: "login",
  unauthorized: "unauthorized",
  maintenance: "maintenance",
  loginRedirect: "handle-callback",
  notFound: "notFound",
  releaseNotes: "releaseNotes",
  error: "error",
  forbidden: "forbidden",
  addDevice: "add-device",
  iap: {
    iapHome: "iap",
    iapList: "iap.list",
    pricingTemplates: "iap.pricingTemplates",
    appPricingTemplates: "iap.appPricingTemplates",
    appPricingTemplateDetails: "iap.appPricingTemplatesDetails",
    pricingTemplateDetails: "iap.pricingTemplateDetails",
  },
  offersAndStore: {
    offersAndStoreHome: "offersAndStore",
    tabs: {
      offers: "offers",
      offerCampaigns: {
        campaignList: "campaignList",
        offerList: "offerList",
        offerDetails: "offerDetails",
        createCampaign: "createCampaign",
      },
      items: "items",
      rewards: "rewards",
      store: "store",
    },
  },
  games: {
    list: "gamesList",
    import: "gameImport",
    display: "gameDisplay",
    error: "gameError",
    home: "gameHome",
    publish: "gamePublish",
    partialPublish: "gamePartialPublish",
    classes: {
      list: "classesList",
      new: "newClass",
      edit: "editClass",
      preview: "previewClass",
      importFromCatalog: "classesCatalogImport",
    },
    features: {
      list: "featuresList",
      edit: "editFeature",
      preview: "previewFeature",
      create: "createFeature",
      createPayment: "createPaymentFeature",
      editPayment: "editPaymentFeature",
      previewPayment: "previewPaymentFeature",
    },
    actionLogs: "actionLogsList",
    versionHistoryList: "versionHistoryList",
    versionHistoryDetail: "versionHistoryDetail",
    segments: {
      list: "segmentsList",
      new: "newSegment",
      edit: "editSegment",
      duplicate: "duplicateSegment",
      preview: "previewSegment",
    },
    testDevices: {
      list: "testDeviceAssignationsList",
      editExternalDevices: "testDevicesEditExternalDevices",
    },
    sandboxes: {
      list: "sandboxesList",
      display: "displaySandbox",
    },
    configurations: {
      list: "configurationsList",
      newRule: "newConfigurationRule",
      editRule: "editConfigurationRule",
      previewRule: "previewConfigurationRule",
      duplicateRule: "duplicateConfigurationRule",
    },
    simulator: "configurationSimulator",
    userInspector: "userInspector",
    abtests: {
      list: "abtestsList",
      new: "newABTest",
      edit: "editABTest",
      review: "reviewABTest",
      dynamicTreatment: "dynamicTreatment",
      addClasses: "addABTestClasses",
      copyClasses: "copyABTestClasses",
      cohorts: {
        list: "listCohorts",
        new: "newCohort",
        edit: "editCohort",
        duplicate: "duplicateCohort",
      },
      layers: {
        new: "newLayer",
        edit: "editLayer",
      },
    },
  },
};
